var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddNodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5C3.86675 0.5 0.5 3.86675 0.5 8C0.5 12.1333 3.86675 15.5 8 15.5C12.1333 15.5 15.5 12.1333 15.5 8C15.5 3.86675 12.1333 0.5 8 0.5ZM8 2C11.3226 2 14 4.67741 14 8C14 11.3226 11.3226 14 8 14C4.67741 14 2 11.3226 2 8C2 4.67741 4.67741 2 8 2Z",
    fill: "#7043FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.2497C7.80109 4.2497 7.61032 4.32873 7.46967 4.46938C7.32902 4.61004 7.25 4.80079 7.25 4.9997V7.2497H5C4.80109 7.2497 4.61032 7.32873 4.46967 7.46938C4.32902 7.61004 4.25 7.80079 4.25 7.9997C4.25 8.19861 4.32902 8.38939 4.46967 8.53004C4.61032 8.6707 4.80109 8.7497 5 8.7497H7.25V10.9997C7.25 11.1986 7.32902 11.3894 7.46967 11.53C7.61032 11.6707 7.80109 11.7497 8 11.7497C8.19891 11.7497 8.38968 11.6707 8.53033 11.53C8.67098 11.3894 8.75 11.1986 8.75 10.9997V8.7497H11C11.1989 8.7497 11.3897 8.6707 11.5303 8.53004C11.671 8.38939 11.75 8.19861 11.75 7.9997C11.75 7.80079 11.671 7.61004 11.5303 7.46938C11.3897 7.32873 11.1989 7.2497 11 7.2497H8.75V4.9997C8.75 4.80079 8.67098 4.61004 8.53033 4.46938C8.38968 4.32873 8.19891 4.2497 8 4.2497Z",
    fill: "#7043FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNodeIcon);
export default __webpack_public_path__ + "static/media/add_node_icon.24b85e0b1e48f6a655b36096d7ccaf66.svg";
export { ForwardRef as ReactComponent };